import SecurityReportService from "../../services/SecurityReportService";

class ReportDetailsManager {
  async getReportById(reportId) {
    return SecurityReportService.getReportById(reportId).then(answer => answer && answer.data);
  }
}

export default new ReportDetailsManager();
